import BaseApi from 'api/BaseApi';

export interface IApplicationDocumentConfiguration {
  id: string;
  name: string;
  position: number;
  folderId?: string | null;
  required?: boolean;
  productId: string;
  organizationId: string;
}

interface IApplicationDocumentConfigurationApi {
  getApplicationDocumentsConfiguration(productId: string): Promise<IApplicationDocumentConfiguration[]>;
}

export default class ApplicationDocumentConfigurationRestApi extends BaseApi implements IApplicationDocumentConfigurationApi {
  public getApplicationDocumentsConfiguration(product: string): Promise<IApplicationDocumentConfiguration[]> {
    const urlParams = new URLSearchParams();

    urlParams.append('productId', product);

    return this.fetch(`/application-document-configurations?${urlParams}`);
  }
}
